import Ajax from '@utils/ajax';

export default {
  get(group, id, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/rec_object_customizations/${id}`,
      ...options,
    });
  },

  create(group, recObject, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_objects/${recObject.id}/rec_object_customizations`,
      data: {
        customization: data,
      },
      ...options,
    });
  },

  destroy(group, recObject, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/rec_objects/${recObject.id}/rec_object_customizations/x`,
      data: {
        _method: 'DELETE',
      },
      ...options,
    });
  },
};
